/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { NewContentDto } from './NewContentDto';
export type NewsDto = {
    readonly id?: string;
    readonly createdDate?: string;
    readonly createdBy?: string;
    readonly modifiedDate?: string;
    readonly modifiedBy?: string;
    readonly version?: number;
    newsState: NewsDto.newsState;
    publishDate?: string;
    contactPhoneNumber?: string;
    contactEmail?: string;
    author?: string;
    contents: Array<NewContentDto>;
};
export namespace NewsDto {
    export enum newsState {
        DRAFT = 'DRAFT',
        UPCOMING = 'UPCOMING',
        PUBLISHED = 'PUBLISHED',
    }
}

